import React from 'react'
import { formatFeeLine } from '../../lib/fees'

/**
 * States the platform fee taken from each gift. Renders nothing until the fee
 * schedule is known.
 */
export default function FeeDisclosure({ percent, fixedCents, parishName }) {
  if (typeof percent !== 'number' || typeof fixedCents !== 'number') return null
  return (
    <p data-testid="fee-disclosure" className="text-xs text-charcoal-muted text-center mt-2">
      {formatFeeLine(percent, fixedCents, parishName)}
    </p>
  )
}
